"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.school = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var school = function school(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'school-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M3.75 13.4523L3.75 10.3604C3.75 9.94617 4.08579 9.61038 4.5 9.61038C4.91421 9.61038 5.25 9.94617 5.25 10.3604L5.25 13.4523C5.25 13.8665 4.91421 14.2023 4.5 14.2023C4.08579 14.2023 3.75 13.8665 3.75 13.4523Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M3.75 13.4523C3.75 13.038 4.08579 12.7023 4.5 12.7023V13.4523C4.5 12.7023 4.50073 12.7023 4.50147 12.7023L4.50294 12.7023L4.50591 12.7023L4.51191 12.7023L4.52421 12.7026C4.53255 12.7029 4.54119 12.7033 4.55014 12.7038C4.56803 12.7048 4.58733 12.7065 4.60821 12.7088C4.64983 12.7134 4.69874 12.7209 4.75646 12.7324C4.87129 12.7554 5.02686 12.7956 5.23717 12.8657C5.65644 13.0055 6.31554 13.2715 7.33541 13.7814C8.37187 14.2997 9.15395 14.7965 9.68177 15.1681C9.9457 15.3539 10.1462 15.5085 10.2832 15.619C10.3517 15.6742 10.4044 15.7184 10.4412 15.75C10.4596 15.7657 10.4741 15.7784 10.4846 15.7876L10.4974 15.799L10.5015 15.8027L10.5031 15.8041L10.504 15.8049C10.5041 15.805 10.5042 15.8052 10 16.3604L10.504 15.8049C10.8106 16.0834 10.8337 16.558 10.5552 16.8646C10.277 17.171 9.80327 17.194 9.49661 16.9163C9.49641 16.9162 9.4968 16.9165 9.49661 16.9163L9.49198 16.9122C9.48685 16.9077 9.47788 16.8999 9.46504 16.8889C9.43937 16.8669 9.39829 16.8323 9.34181 16.7868C9.22884 16.6957 9.0543 16.5608 8.81823 16.3946C8.34605 16.0621 7.62813 15.6048 6.66459 15.1231C5.68446 14.633 5.09356 14.399 4.76283 14.2888C4.59814 14.2339 4.50371 14.2116 4.46229 14.2033C4.45551 14.202 4.45035 14.201 4.44671 14.2004C4.05736 14.1731 3.75 13.8486 3.75 13.4523Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M16.25 13.4523C16.25 13.038 15.9142 12.7023 15.5 12.7023V13.4523C15.5 12.7023 15.4993 12.7023 15.4985 12.7023L15.4971 12.7023L15.4941 12.7023L15.4881 12.7023L15.4758 12.7026C15.4674 12.7029 15.4588 12.7033 15.4499 12.7038C15.432 12.7048 15.4127 12.7065 15.3918 12.7088C15.3502 12.7134 15.3013 12.7209 15.2435 12.7324C15.1287 12.7554 14.9731 12.7956 14.7628 12.8657C14.3436 13.0055 13.6845 13.2715 12.6646 13.7814C11.6281 14.2997 10.846 14.7965 10.3182 15.1681C10.0543 15.3539 9.85384 15.5085 9.71681 15.619C9.64829 15.6742 9.59562 15.7184 9.55879 15.75C9.54038 15.7657 9.52592 15.7784 9.51542 15.7876L9.50264 15.799L9.49847 15.8027L9.49694 15.8041L9.49604 15.8049C9.49591 15.805 9.49579 15.8052 10 16.3604L9.49604 15.8049C9.1894 16.0834 9.16631 16.558 9.44478 16.8646C9.723 17.171 10.1967 17.194 10.5034 16.9163C10.5032 16.9165 10.5036 16.9162 10.5034 16.9163L10.508 16.9122C10.5131 16.9077 10.5221 16.8999 10.535 16.8889C10.5606 16.8669 10.6017 16.8323 10.6582 16.7868C10.7712 16.6957 10.9457 16.5608 11.1818 16.3946C11.654 16.0621 12.3719 15.6048 13.3354 15.1231C14.3155 14.633 14.9064 14.399 15.2372 14.2888C15.4019 14.2339 15.4963 14.2116 15.5377 14.2033C15.5445 14.202 15.5497 14.201 15.5533 14.2004C15.9426 14.1731 16.25 13.8486 16.25 13.4523Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M14.75 13.3604L14.75 10.3604C14.75 9.94617 15.0858 9.61038 15.5 9.61038C15.9142 9.61038 16.25 9.94617 16.25 10.3604L16.25 13.3604C16.25 13.7746 15.9142 14.1104 15.5 14.1104C15.0858 14.1104 14.75 13.7746 14.75 13.3604Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M18.75 8.95924C18.7473 9.24082 18.5872 9.4972 18.3353 9.62311L10.5173 13.5312C10.3104 13.6346 10.0674 13.6368 9.85872 13.5371L1.67674 9.62902C1.41822 9.50553 1.25263 9.24555 1.25003 8.95905C1.24743 8.67256 1.40828 8.40961 1.66453 8.28146L9.84651 4.18959C10.062 4.0818 10.3163 4.08414 10.5298 4.19589L18.3478 8.28777C18.5973 8.41834 18.7526 8.67766 18.75 8.95924ZM10.1742 5.70283L3.70771 8.93678L10.1745 12.0256L16.3533 8.93692L10.1742 5.70283Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M18.75 8.95226V14.9523H17.25V8.95226H18.75Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M19 14.9523C19 15.5045 18.5523 15.9523 18 15.9523C17.4477 15.9523 17 15.5045 17 14.9523C17 14.4 17.4477 13.9523 18 13.9523C18.5523 13.9523 19 14.4 19 14.9523Z',
    fill: '#4B5563'
  }));
};

exports.school = school;